function adventInitFormToggle() {
    // 1. set link to form modal toggle
    $('.advent-detail-container').find('.advent-answer__link').attr('data-trigger-form-modal', '');
    // 2. manually initialize form toggle
    $(window).trigger('initFormModalTrigger');
}

$(function() {
    const $advent_plugin = $('.advent-plugin');
    const $advent_detail_container = $advent_plugin.find('.advent-detail-container');
    const $today = $advent_plugin.find('.advent-detail-prepared[data-today]');

    // always show the calender from today
    $advent_detail_container.html($today.html());

    // init form toggle on page load
    adventInitFormToggle();

    // when clicked show the requested day
    $('.advent-number > a').on('click', function(e) {

        // init
        e.preventDefault();
        let $trigger = $(this);
        let id = $trigger.data('id');

        let initialized_attr = 'data-trigger-disabled';
        // check for initialized trigger
        let trigger_disabled = $trigger.attr(initialized_attr);
        // DISABLED, adios!
        if (typeof trigger_disabled !== 'undefined') {
            return false;
        }

        // get and write content
        let $content = $advent_plugin.find('.advent-detail-prepared[data-id="' + id + '"]');
        $advent_detail_container.html($content.html());

        let window_width = $(window).width();
        let extra_padding_offset = 50;
        let header_offset = 0;
        // mobile
        if (window_width < 768) {
            header_offset = 70;
        }
        // desktop
        else {
            header_offset = 85;
        }

        // re-init form toggle
        adventInitFormToggle();

        // scroll to detail
        $('html, body').animate({
            scrollTop: $advent_detail_container.offset().top - (header_offset + extra_padding_offset),
        }, 400);

    });

});



// WEBPACK FOOTER //
// ./static/js/modules/advent.js